import {
  Map as MapboxMap,
  NavigationControl,
  ScaleControl,
  Popup,
  FullscreenControl,
  GeolocateControl,
} from 'mapbox-gl';
import {
  BOUNDS_SMALL,
  BOUNDS_LARGE,
  TILESET,
  STYLE,
  SOURCE,
  SOURCE_LAYER,
  TOKEN,
} from './maputils/constants';

import { findElementByIdInShadowDom } from './utils/render.js';

let w = window.innerWidth;
const bounds = w < 500 ? BOUNDS_SMALL : BOUNDS_LARGE;

/**
 *
 * @param {Element} container
 */

export async function renderShapesMap(container) {
  // create our popup but don't add to the map for now
  const popup = new Popup({
    closeButton: false,
    closeOnClick: false,
    offset: 8,
  });

  // create our map - options you can add https://docs.mapbox.com/mapbox-gl-js/api/map/
  const map = new MapboxMap({
    accessToken: TOKEN,
    container,
    style: STYLE,
    // bounds,
    center: [-118.197326, 33.912261],
    zoom: 9,
    minZoom: 8,
    cooperativeGestures: true,
  });

  // disable map rotation using right click + drag
  map.dragRotate.disable();

  // disable map rotation using touch rotation gesture
  map.touchZoomRotate.disableRotation();

  // Add controls to the map

  // fullscreen button
  // map.addControl(new FullscreenControl());

  map.addControl(new NavigationControl({ showCompass: false }));
  map.addControl(new ScaleControl({ unit: 'imperial' }), 'bottom-right');

  // we wait for it to fully load so we can add sources and layers
  await map.once('load');

  // add our data source
  map.addSource(SOURCE, {
    type: 'vector',
    url: TILESET,
    // promoteId: 'some unique id in tileset like precinctID', // use this for most cases and comment out genreated ID below
    generatedId: true, // use this if your tileset was generated and uploaded using tippecanoe
  });
}
